import React, { useEffect, useState } from "react";
import "./ManualDepositPopup.css";
import { IoChevronBackSharp } from "react-icons/io5";
import {
  __,
  addNewStyle,
  API,
  CRISTP_ID,
  decode,
  defaultAvatar,
  encode,
  getUID,
  sendNotfication,
  toUSD,
  wait,
} from "../../../Helper";
import axios from "axios";
import Cookies from "js-cookie";
import Storage from "../../../Storage";

function QrManualDeposit({ isOpen, onClose, amount }) {
  const [utrNumber, setUtrNumber] = useState("");
  const [depositPaymentSetting, setDepositPaymentSetting] = useState({});
  const [step, setStep] = useState(1);
  const [depositType, setDepositType] = useState("manual");
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState(null); // ✅ Now always called!
  const [copied, setCopied] = useState(false);


  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(
          `${API}/admin/websiteconfig`
        );

        const data = response?.data?.data?.paymentSettings;
        let selected = "usdt"
        let filteredData = data?.filter(item => item?.payment_type === selected && item?.isactive === true);

        console.log("Filtered Data:", filteredData);

        if (filteredData?.length > 0) {
          setSettings(filteredData[0]); // ✅ Uncommented to actually store settings
          console.log("Settings:", filteredData[0]);
        }

      } catch (error) {
        console.error("Error fetching payment settings:", error);
      }
    };

    fetchSettings();
  }, []); // ✅ Ensures it only runs once

  // ✅ Move the conditional rendering AFTER hooks
  if (!isOpen) return null;

  const handleManualDeposit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (window.gtag) {
      window.gtag("event", "deposit_initiated", {
        value: parseFloat(amount) || 0,
        currency: Storage?.getKey("currency") || "INR",
        items: [{ item_name: "Deposit Initiated", price: parseFloat(amount) || 0, quantity: 1 }]
      });
    }

    if (window.fbq) {
      window.fbq('track', 'AddToCart');
    }

    try {
      const response = await axios.post(
        `${API}/payment/api/paynow/manual`,
        {
          money: parseFloat(amount),
          uid: parseFloat(Cookies.get("uid")),
          utrNumber: utrNumber,
        }
      );

      const data = response?.data;

      if (!data || data?.status === false) {
        sendNotfication(
          data?.message || "Payment failed! Please try again.",
          "danger",
          "bottom-left"
        );
      } else {
        sendNotfication(data.message, "success", "bottom-left");
        if (window.gtag) {
          window.gtag("event", "purchase", {
            transaction_id: utrNumber || "",
            value: parseFloat(amount) || 0,
            currency: Storage?.getKey("currency") || "INR",
            items: [
              {
                item_name: "Manual Deposit",
                price: parseFloat(amount) || 0,
                quantity: 1
              }
            ]
          });
        }
        if (window.fbq) {
          window.fbq('track', 'Purchase', {
            value: parseFloat(amount) || 0,
            currency: Storage?.getKey("currency") || "INR",
            content_ids: [utrNumber || 'deposit'],
            content_type: 'product'
          });
        }
      }
    } catch (error) {
      console.error("Error during gateway deposit:", error);
      sendNotfication(
        "An unexpected error occurred! Please try again later.",
        "danger",
        "bottom-left"
      );
    } finally {
      setLoading(false);
    }
  };


  const handleCopy = () => {
    if (settings?.usdt_address) {
      navigator.clipboard.writeText(settings.usdt_address);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1500); // Reset after 1.5 seconds
    }
  };


  return (
    <div className="popup-overlay-inner-main-543">
      <div className="popup-container-inner-main-543">
        <div className="vip2-popup-page" style={{ background: "#000" }}>
          <div className="vip2-popup-page-btn" onClick={onClose}>
            <IoChevronBackSharp />
          </div>
          Manual Method
        </div>
        <div
          className="main-int-overflow-sroll"
          style={{
            padding: "20px",
            background: "#232626",
            borderRadius: "0px 0px 10px 10px ",
          }}
        >
          <div
            style={{
              background: "#000",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <div style={{ marginBottom: "20px" }} className="main-int-uew-1235">
              <div className="main-int-uew-1236">Deposit Currency</div>
              <div className="main-int-uew-1237">
                <img
                  className="main-int-uew-1238"
                  src="/assets/bcimages/USDT.png"
                  alt="USDT"
                />
                <div>{Storage?.getKey("currency")}</div>
              </div>
            </div>
            <div className="main-int-uew-new-1">Manual Deposit</div>
            <div className="popup-body-inner-main-543">
              {/* <div style={{ textAlign: "start" }}>
                <img style={{ width: "60px" }} src="/assets/images/USDT.png" />
              </div> */}
              <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#FF9820" }}>
                Amount: ${amount}
              </div>
            </div>

            {/* <div
              style={{
                margin: "20px 0px",
                background: "#514634",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                borderRadius: "10px",
              }}
            >
              <img
                style={{ width: "50px" }}
                src="/assets/images/bonus-gift.webp"
              />
              <div style={{ fontWeight: "bold", textAlign: "start" }}>
                Get extra <span style={{ color: "#FF9820" }}>180%</span> bonus
                on minimum of{" "}
                <span style={{ color: "#FF9820" }}>$1,056.84</span> deposit
              </div>
            </div> */}

            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontSize: ".9rem", fontWeight: "bold", marginBottom: "10px" }}>
                Scan QR code or enter TRX Number
              </div>

              <div
                style={{
                  padding: "0.5rem 0.75rem",
                  marginTop: "0.5rem",
                  borderRadius: "0.5rem",
                  border: "1px solid #BFDBFE",
                  marginBottom: "0.75rem",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontWeight: 500, fontSize: "0.75rem" }}>
                  {settings?.usdt_address}
                </span>

                <button
                  onClick={handleCopy}
                  style={{
                    border: "none",
                    background: "#E5F0FF",
                    color: "#2563EB",
                    fontSize: "0.75rem",
                    fontWeight: 500,
                    padding: "4px 8px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  {copied ? "Copied!" : "Copy"}
                </button>
              </div>


              <img style={{ width: "200px" }} src={
                settings?.usdt_qr_img?.startsWith("data:image")
                  ? settings?.usdt_qr_img // Show selected image preview
                  : `${API}/uploads/QrCodes/${settings?.usdt_qr_img}`
              }
                alt="" />
              <div style={{ fontSize: ".8rem", marginTop: "10px", color: "#B3BEC1" }}>
                Scan the QR code above to make the payment or enter TRX below to confirm:
              </div>
            </div>

            <div className="main-int-uew-new-1">TRX Number:</div>

            <div className="popup-body-inner-main-543">
              <input
                className="amount-input-inner-main-543"
                type="number"
                placeholder="Enter TRX Number"
                value={utrNumber}
                onChange={(e) => setUtrNumber(e.target.value)}
              />
              <button
                onClick={handleManualDeposit} className="submit-button-inner-main-543">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QrManualDeposit;
